import type { ReactNode } from 'react'
import type { MenuItemGroup } from '@app/types/menu'

export const getItemsWithCollapseElement = (items: MenuItemGroup[], collapseElement: ReactNode): typeof items => {
  return items.map(item => ({
    ...item,
    label: collapseElement
  }))
}
